import React from 'react';
import { containerStyles, MainContentContainer, resolver, SideMargin, ThemeKeys, themes, UnderConstruction } from '@clinicaltoolkits/universal-react-components';
import { Container, Group, MantineProvider } from '@mantine/core';
import { cssVariableOverrides, universalStyles } from './styles';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { SiteHeader } from './components';
import { Main, About } from './views';
import { Team } from './views/about/Team';

export const App = () => {
  const [themeKey, setThemeKey] = React.useState<ThemeKeys>(ThemeKeys.Default);
  
  return (
    <MantineProvider theme={themes[themeKey]} cssVariablesResolver={resolver(themeKey, cssVariableOverrides)} defaultColorScheme='auto'>
      <BrowserRouter>
        <RoutesWrapper />
      </BrowserRouter>
    </MantineProvider>
  );
};

const RoutesWrapper: React.FC = () => {
  return (
    <Container fluid className={`${containerStyles.parentContainer} ${universalStyles.root}`}>
      <SiteHeader />
      <Group style={{ alignItems: "stretch", flexGrow: 1 }}>
        <SideMargin />
        <Routes>
          <Route path="" element={<Main />} />
          <Route path="about" element={<About />} />
          <Route path="about/team" element={<Team />} />
          <Route path="services" element={<MainContentContainer><UnderConstruction constructionTarget='Services' percentComplete={15} subheadingText="Are on their way!" brandName="AI Live" /></MainContentContainer>} />
          <Route path="fees" element={<MainContentContainer><UnderConstruction constructionTarget='Fees' percentComplete={15} subheadingText="We're working on it!" brandName="AI Live" /></MainContentContainer>} />
          <Route path="contact" element={<MainContentContainer><UnderConstruction constructionTarget='Contact' percentComplete={25} subheadingText="Just about there!" brandName="AI Live" /></MainContentContainer>} />
        </Routes>
        <SideMargin />
      </Group>
    </Container>
  );
};
